import { Link, useParams, Navigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";
import { getStoryBySlug, TEAM_STORIES } from "../data/teamStories";
import "./SuccessStory.css";

function StoryParagraphs({ text }) {
  const sentences = text.split(/(?<=[.!?])\s+/).filter(Boolean);

  return (
    <div className="story-paragraphs">
      {sentences.map((sentence) => (
        <p key={sentence}>{sentence}</p>
      ))}
    </div>
  );
}

export default function SuccessStory() {
  const { slug } = useParams();
  const story = getStoryBySlug(slug);

  if (!story) return <Navigate to="/" replace />;

  const related = TEAM_STORIES.filter((s) => s.slug !== slug).slice(0, 2);

  return (
    <div className="story-page">
      <Navbar />
      <main className="story-main">
        <div className="container story-container">
          <nav className="story-breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <Link to="/#team">Team</Link>
            <span>/</span>
            <span>{story.name}</span>
          </nav>

          <header className="story-header">
            <span className="story-label">Team Story</span>
            <h1>{story.headline}</h1>
            <p className="story-subtitle">{story.subtitle}</p>
          </header>

          <div className="story-hero-grid">
            <div className="story-hero-text">
              <section>
                <h2>Overview</h2>
                <StoryParagraphs text={story.overview} />
              </section>
            </div>
            <div className="story-hero-image">
              <img src={story.image} alt={story.name} />
            </div>
          </div>

          <blockquote className="story-pull-quote">
            &ldquo;{story.quote}&rdquo;
            <footer>
              — {story.name}, {story.role} at {story.company}
            </footer>
          </blockquote>

          <section className="story-section">
            <h2>Challenge</h2>
            <StoryParagraphs text={story.challenge} />
          </section>

          <section className="story-section">
            <h2>Solution</h2>
            {story.solution.map((item) => (
              <div key={item.title} className="story-solution-item">
                <h3>{item.title}</h3>
                <StoryParagraphs text={item.text} />
              </div>
            ))}
          </section>

          <section className="story-section">
            <h2>Impact</h2>
            <ul className="story-impact-list">
              {story.impact.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <div className="story-meta">
            <div>
              <span className="story-meta-label">Use Case</span>
              <p>{story.useCase}</p>
            </div>
            <div>
              <span className="story-meta-label">Focus Areas</span>
              <p>{story.products.join(" · ")}</p>
            </div>
          </div>

          {related.length > 0 && (
            <section className="story-related">
              <h2>More Team Stories</h2>
              <div className="story-related-grid">
                {related.map((s) => (
                  <Link
                    key={s.slug}
                    to={`/team/${s.slug}`}
                    className="story-related-card"
                  >
                    <img src={s.image} alt={s.name} />
                    <div>
                      <h3>{s.name}</h3>
                      <p>{s.role}</p>
                      <span>Read story →</span>
                    </div>
                  </Link>
                ))}
              </div>
            </section>
          )}

          <div className="story-cta">
            <h2>Need AC service in Kamra or Attock?</h2>
            <Link to="/#request-form" className="btn btn-primary">
              Book a Verified Technician
            </Link>
          </div>
        </div>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
